import { useCallback, useState } from 'react';
import { useLanguage } from '../../../contexts/useLanguage';
import { useWebDesignedCart } from '../../../contexts/WebDesignedCartContext';
import type { Activity } from '../../../types';
import { useActivitiesWithImages } from '../useActivitiesWithImages';

export type HomeActivitiesSeasonFilter = 'summer' | 'winter' | 'all_year';

export function useHomeActivities() {
  const { t } = useLanguage();
  const cart = useWebDesignedCart();
  const activities = useActivitiesWithImages();

  const [seasonFilter, setSeasonFilter] = useState<HomeActivitiesSeasonFilter>('all_year');

  // "All year" = show every activity (summer-only, winter-only, all-season, etc.), not only `toute_année`.
  const featured =
    seasonFilter === 'summer'
      ? activities.filter((a) => a.type === 'été')
      : seasonFilter === 'winter'
        ? activities.filter((a) => a.type === 'hiver')
        : activities;

  const onBookActivity = useCallback(
    (activity: Activity) => {
      cart?.openReservationForm('activity', activity.id, activity.name, activity.price);
    },
    [cart]
  );

  return { t, seasonFilter, setSeasonFilter, featured, onBookActivity };
}
